export const scaledDownFontStyles = (fontSize) => {
    const fontRequested = [];
    switch (fontSize) {
        case 'heading-1':
            fontRequested.push('text-xlarge', 'mdOnly:leading-6');
            break;
        case 'heading-2':
            fontRequested.push('text-xlarge', 'mdOnly:leading-6');
            break;
        case 'heading-3':
            fontRequested.push('text-lg', 'mdOnly:leading-[22px]');
            break;
        case 'heading-4':
            fontRequested.push('text-lg', 'mdOnly:leading-[22px]');
            break;
        case 'heading-5':
            fontRequested.push('text-base', 'mdOnly:leading-5');
            break;
        case 'heading-6':
            fontRequested.push('text-base', 'mdOnly:leading-5');
            break;
        default:
            fontRequested.push('text-base', 'mdOnly:leading-5');
            break;
    }
    return fontRequested;
};

export const mobileFontSize = (component) => {
    const fontRequested = [];
    switch (component) {
        case 'primaryHeadline':
            fontRequested.push('smOnly:heading-6', 'smOnly:leading-9');
            break;
        case 'primarySubHeadline':
            fontRequested.push('smOnly:text-xlarge', 'smOnly:leading-6');
            break;
        case 'secondaryHeadline':
            fontRequested.push('smOnly:text-2xlarge', 'smOnly:leading-8');
            break;
        case 'secondarySubHeadline':
            fontRequested.push('smOnly:text-base', 'smOnly:leading-5');
            break;
        default:
            fontRequested.push('smOnly:text-base', 'smOnly:leading-5');
            break;
    }
    return fontRequested;
};
